import { useContext, useEffect, useState } from "react";
import axiosInstance from "../../utils/axios";
import {
  Button,
  Card,
  Dropdown,
  notification,
  Row,
  Space,
  Table,
  Tag,
  Tooltip,
} from "antd";
import { useTranslation } from "react-i18next";
import { DownOutlined } from "@ant-design/icons";
import classes from "../Etablissements/Etablissements.module.css";
import { useLoader } from "../../context/LoaderContext";
import { useNavigate } from "react-router-dom";
import ModalChooseTypeHomolaguation from "./ModalChooseTypeHomolaguation/ModalChooseTypeHomolaguation";
import {
  checkHomologationByIdFormation,
  checkSessionByIdFormation,
  getCheckModificationApprenant,
  getDetailsHomologation,
} from "../../api/geoprod";
import GlobalContext from "../../context/GlobalContext";

const ListFomrations = () => {
  const [listFomrations, setListFormations] = useState([]);
  const [loading, setLoading] = useState(true);
  const { t, i18n } = useTranslation();
  const { setIsLoading, setSurveyJson, setSurveyData } = useLoader();
  const [openModal, setOpenModal] = useState("");
  const { setCurrentStep } = useContext(GlobalContext);
  const navigate = useNavigate();
  const columns = [
    {
      title: t("Numéro d'enregistrement"),
      key: "Numéro d'enregistrement",
      render: (_, record) => record?.registration_number,
    },
    {
      title: t("Dénomination"),
      key: "dénomination",
      render: (_, record) => (
        <Tooltip title={record?.nom_etablissement}>
          <span
            style={{
              display: "inline-block",
              maxWidth: 150,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {record?.nom_etablissement}
          </span>
        </Tooltip>
      ),
    },
    {
      title: t("Nature de formation"),
      dataIndex: "directeur",
      key: "directeur",
      render: (_, record) =>
        record?.training_nature_data?.training_type_data_nature,
    },
    {
      title: t("Exigence d’homologation"),
      key: "gouvernorat",
      render: (_, record) =>
        record?.training_nature_data?.training_type_data_type &&
        record?.training_nature_data?.training_type_data_nature === "أساسي"
          ? record?.training_nature_data?.training_type_data_type
          : t("غير منظرة"),
    },
    {
      title: t("Spécialité ou Domaine"),
      key: "natureForm",
      render: (_, record) => {
        const text =
          record?.training_nature_data?.training_type_data_specialty ||
          record?.training_nature_data?.training_type_data_domain ||
          t("Non renseigné");

        return (
          <Tooltip title={text}>
            <span
              style={{
                display: "inline-block",
                maxWidth: 150,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {text}
            </span>
          </Tooltip>
        );
      },
    },
    // {
    //   title: t("Domaine"),
    //   key: "Domaine",
    //   render: (_, record) =>
    //     record?.training_nature_data?.training_type_data_domain ||
    //     t("Non renseigné"),
    // },
    {
      title: t("Date rajout"),
      key: "datedebut",
      render: (_, record) => record?.date_debut_formation || t("Non renseigné"),
    },
    {
      title: t("Date suppression"),
      key: "datefin",
      render: (_, record) => record?.date_fin_formation || t("Non renseigné"),
    },
    {
      title: t("Homologation"),
      dataIndex: "homologation",
      key: "homologation",
      render: (_, record) => (
        <Tag color={ record?.training_nature_data?.training_type_data_type!== "منظرة" ? "#A0A0A0": record.statut_formation === 0 ? "#FF808B" : record?.possede_homologation === 1 ? "#009AAB" :"#FFB300"}>
          {record?.training_nature_data?.training_type_data_type !== "منظرة"
            ? t("Non concernée")
            : record.statut_formation === 0
            ? t("Supprimée")
            : record?.possede_homologation === 1
            ? t("Homologation active")
            : t("Homologation inactive")}
        </Tag>
      ),
    },

    {
      title: t("Actions"),
      key: "Actions",
      render: (_, record) => (
        <Space>
          <Dropdown
            menu={{
              items: [
                {
                  label: (
                    <Button
                      onClick={() => ConsultFormationDetails(record)}
                      size="small"
                      block
                    >
                      {t("Consulter")}
                    </Button>
                  ),
                },
                record?.training_nature_data?.training_type_data_type ===
                  "منظرة" &&
                  role !== "investisseur" &&
                  record?.details_specialite?.id_diplome !== 1 && {
                    label: (
                      <Button
                        size="small"
                        block
                        onClick={() => {
                          setIsLoading(true);
                          axiosInstance
                            .get(
                              `${
                                import.meta.env.VITE_APP_GEOPROD_API
                              }/check_homologation_by_id_formation/${
                                record?.id
                              }`,
                              {
                                headers: {
                                  Idsession: JSON.parse(
                                    sessionStorage.getItem("-x-token-user")
                                  )?.Acces_Token,
                                },
                              }
                            )
                            .then((res) => {
                              setIsLoading(false);
                              if (!res?.data?.message?.relance) {
                                notification.info({
                                  message: t("info"),
                                  description: t(
                                    "Une demande d'homologation pour cette spécialité est déjà en cours de traitement, ou un brouillon existe déjà pour ce type de demande."
                                  ),
                                  duration: 0,
                                });
                              } else {
                                sessionStorage.setItem("consulter", false);
                                const data = {
                                  id: record?.id,
                                  data: record,
                                };
                                setOpenModal(JSON.stringify(data));
                              }
                            });
                        }}
                      >
                        {t("Homologuer")}
                      </Button>
                    ),
                  },

                record?.training_nature_data?.training_type_data_type ===
                  "منظرة" && {
                  label: (
                    <Button
                      size="small"
                      block
                      onClick={() => {
                        navigate("/pre-inscrit/" + record?.id);
                      }}
                    >
                      {t("Nouvelle demande d'éligibilité")}
                    </Button>
                  ),
                },
                record?.training_nature_data?.training_type_data_type ===
                  "منظرة" &&
                  record?.training_nature_data?.training_type_data_nature ===
                    "أساسي" && {
                    label: (
                      <Button
                        size="small"
                        block
                        onClick={() => {
                          setIsLoading(true);
                          checkHomologationByIdFormation(record?.id)
                            .then((responseHomologation) => {
                              // if(responseHomologation?.message?.homologuer){
                              if (responseHomologation?.message?.homologuer) {
                                checkSessionByIdFormation(record?.id)
                                  .then((responseSession) => {
                                    // if (!responseSession?.existe)
                                    if (responseSession?.existe) {
                                      getDetailsHomologation(record?.id)
                                        .then((response) => {
                                          sessionStorage.removeItem(
                                            "globalData"
                                          );
                                          sessionStorage.removeItem(
                                            "currentStep"
                                          );
                                          setCurrentStep(0);
                                          navigate(
                                            "/formations/lancementSessionFormationHomologuee",
                                            {
                                              state: {
                                                dataHomologation:
                                                  response?.message,
                                                id_formation: record?.id,
                                              },
                                            }
                                          );
                                          setIsLoading(false);
                                        })
                                        .catch((error) => {
                                          notification.error({
                                            message: t("Erreur"),
                                            description: t(
                                              error?.data?.message
                                            ),
                                            duration: 0,
                                          });
                                          setIsLoading(false);
                                        });
                                    } else {
                                      notification.info({
                                        message: t("info"),
                                        description: t(
                                          "Une demande de lancement de session de formation pour cette spécialité est déjà en cours de traitement, ou un brouillon existe déjà pour ce type de demande."
                                        ),
                                        duration: 0,
                                      });
                                      setIsLoading(false);
                                    }
                                  })
                                  .catch((error) => {
                                    notification.error({
                                      message: t("Erreur"),
                                      description: t(error?.data?.message),
                                      duration: 0,
                                    });
                                    setLoading(false);
                                  });
                              } else {
                                notification.error({
                                  message: t("Erreur"),
                                  description: t("Aucune homologation"),
                                  duration: 0,
                                });
                                setIsLoading(false);
                              }
                            })
                            .catch((error) => {
                              notification.error({
                                message: t("Erreur"),
                                description: t(error?.data?.message),
                                duration: 0,
                              });
                              setIsLoading(false);
                            });
                        }}
                      >
                        {t("Lancement d'une session de formation homologuée")}
                      </Button>
                    ),
                  },

                record?.training_nature_data?.training_type_data_type ===
                  "غير منظرة" &&
                  record?.training_nature_data?.training_type_data_nature ===
                    "أساسي" && {
                    label: (
                      <Button
                        size="small"
                        block
                        onClick={() => {
                          sessionStorage.removeItem("globalData");
                          sessionStorage.removeItem("currentStep");
                          setCurrentStep(0);
                          navigate(
                            "/formations/lancementSessionFormationNonHomologuee",
                            {
                              state: {
                                id_formation: record?.id,
                                dataFormationNonHomloguee: record,
                                natureFormation: "formationNonHomologuee",
                              },
                            }
                          );
                        }}
                      >
                        {t(
                          "Lancement d'une session de formation non homologuée"
                        )}
                      </Button>
                    ),
                  },

                record?.training_nature_data?.training_type_data_nature ===
                  "مستمر" && {
                  label: (
                    <Button
                      size="small"
                      block
                      onClick={() => {
                        sessionStorage.removeItem("globalData");
                        sessionStorage.removeItem("currentStep");
                        setCurrentStep(0);
                        navigate(
                          "/formations/lancementSessionFormationContinue",
                          {
                            state: {
                              id_formation: record?.id,
                              dataFormationNonHomloguee: record,
                              natureFormation: "formationContinue",
                            },
                          }
                        );
                      }}
                    >
                      {t("Lancement d'une session de formation continue")}
                    </Button>
                  ),
                },

                   {
                  label: (
                    <Button
                      size="small"
                      block
                      onClick={() => {
                        sessionStorage.removeItem("globalData");
                        navigate("/validation/session/formation/:id", {
                          state: {
                            id_formation:record?.id,
                            dataFormationNonHomloguee: record,
                          },
                        });
                      }}
                    >
                      {t("Validation session non homologuée / continue")}
                    </Button>
                  ),
                },
              ],
            }}
            trigger={["click"]}
          >
            <span style={{ cursor: "pointer" }}>
              <Space>
                {t("Liste")}
                <DownOutlined />
              </Space>
            </span>
          </Dropdown>
        </Space>
      ),
    },
  ];
  const role = sessionStorage.getItem("role");

  const ConsultFormationDetails = (record) => {
    setIsLoading(true);

    axiosInstance
      .get(
        `${import.meta.env.VITE_APP_GEOPROD_API}/admin-bpm/contrat/${
          import.meta.env
            .VITE_APP_LIGNE_PRODUIT_MODIFIACTION_AVEC_VALIDATION_SANS_BO
        }`,
        {
          headers: {
            Idsession: JSON.parse(sessionStorage.getItem("-x-token-user"))
              ?.Acces_Token,
          },
        }
      )
      .then((res) => {
        setIsLoading(false);
        let form = res?.data?.contrat?.form;
        form.pages = form?.pages.filter((page) => page.name === "page4");
        setSurveyJson(form);
        setSurveyData(record);
        navigate("/formations/details");
      });
  };

  useEffect(() => {
    axiosInstance
      .get(
        `${
          import.meta.env.VITE_APP_GEOPROD_API
        }/admin/get_formations_by_investisseur`,
        {
          headers: {
            Idsession: JSON.parse(sessionStorage.getItem("-x-token-user"))
              ?.Acces_Token,
          },
        }
      )
      .then((res) => {
        setLoading(false);
        res?.data?.message?.forEach((item) => {
          // item.training_nature_data.forEach((e) => {
          setListFormations((prevList) => [
            ...prevList,
            {
              ...item,
            },
          ]);
          // });
        });
      })
      .catch(() => {
        setLoading(false);
      });
  }, []);
  return (
    <Row className={classes.listeRow}>
      <ModalChooseTypeHomolaguation
        openModal={openModal}
        setOpenModal={setOpenModal}
      />

      <Card
        className={classes.listeCard}
        bordered={false}
        title={
          <div>
            <h3
              style={{
                textAlign: i18n?.language === "fr" ? "left" : "right",
              }}
            >
              {t("Liste des spécialités")}
            </h3>
          </div>
        }
      >
        <Table
          locale={{ emptyText: t("Aucune donnée") }}
          loading={loading}
          columns={columns}
          dataSource={listFomrations}
          className="ant-border-space"
          style={{ overflowX: "auto" }}
          pagination={false}
        />
      </Card>
    </Row>
  );
};

export default ListFomrations;
